let scrollY = 0

const onMounted = () => {
  let logoTop = document.getElementById("logoTop");
  logoTop.style.top = `${window.innerHeight / 2}px`

  let logoHeader = document.querySelector('.Header__LogoImage.Header__LogoImage--transparent');
  logoHeader.style.opacity = 0

  handleScrollY()
  window.addEventListener('scroll', handleScrollY, { passive: true })

  window.setTimeout(() => {
    logoTop.classList.remove('js-fadeIn2')
  }, 2500)
}

const handleScrollY = () => {
  let arrowBottom = document.getElementById("arrowBottom");
  arrowBottom.classList.add('js-fadeIn2')
  arrowBottom.classList.remove('on')
  let logoTop = document.getElementById("logoTop");
  let topArea = document.getElementById("topArea");
  let logoHeader = document.querySelector('.Header__LogoImage.Header__LogoImage--transparent');
  scrollY = window.scrollY + logoTop.offsetTop
  let topAreaHeight
  topAreaHeight = topArea.offsetHeight * 2

  // logo-toのopacity調整
  const opacity = 1 - (scrollY - (topAreaHeight * 3) / 4) / ((topAreaHeight * 1) / 4)
  if (opacity >= 0 && opacity < 2) {
    logoTop.style.visibility = 'visible'
    logoTop.style.opacity = opacity
    logoHeader.style.opacity = 1 - opacity
  } else if (opacity < 0) {
    logoTop.style.visibility = 'hidden'
    logoTop.style.opacity = 0
  }

  if(window.scrollY > topAreaHeight) {
    logoHeader.style.opacity = 0
  }
}

onMounted();